import { Alert, Box, Button, Modal, Snackbar, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getCookie } from '../../../utils/getCookie';
import { rutas } from '../../../rutas/rutas';
import axios from 'axios';
import { useSelector } from 'react-redux';
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, sm: 500, md: 1000 },
    height: { xs: 450, sm: 500, md: 600 },
  
    boxShadow: 24,
    p: 0,
  };
const idioma = ''
export const ModalStakePasivo = ({open3 = true, handleClose3}) => {
    const {informacion: {dineroReal: dinero}}  = useSelector(state=> state.userSlice)

    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false)
    const [version, setVersion] = useState("v2")
    const [ kod, setKod ] = useState(0)
    const [ fusion, setFusion ] = useState(0)
    const [ cantidad, setCantidad ] = useState(0)
    const handleClose = () => {
        setOpen(false);
    }
    const depositoPasivo =()=>{
  
        const tokenJWT = getCookie('token')
      
       if(cantidad <= 0 || cantidad > dinero) {

        setOpen(true)
        setError(true)
       
      }
        axios({
          method: 'post',
          url: rutas.ingresoStakeKod + ( version === "v1" ? "" : "v2"),
          headers:  {
            'token': tokenJWT,
            'Content-Type': 'application/json'},
          data: {
            cantidad: cantidad
          }
        }).then(res=>{

          setOpen(true)
          setError(false)
        }).catch(err=> {
     
          setOpen(true)
          setError(true)
        })
      
    }
    const handleMirarPasivo = ()=>{
        const tokenJWT = getCookie('token')
        axios.get(rutas.mirarStakePasivo + ( version === "v1" ? "" : "v2"), { headers: {'token': tokenJWT}}).then(res=>{
          if(res?.data?.cantidad){
            setKod(res?.data?.cantidad)
            setFusion(res?.data?.fusion)
          }
  
        
          
        })
      }

      const handleRetirarPasivo = ()=>{
        const tokenJWT = getCookie('token')
        axios.get(rutas.retirarStakePasivo + ( version === "v1" ? "" : "v2"), { headers: {'token': tokenJWT}}).then(res=>{
          if(res?.data){
            setKod(0)
            setFusion(0)
            setOpen(true)
            setError(false)
          }
  
        
          
        }).catch(err=>{
          setOpen(true)
          setError(true)
        })
      }
 useEffect(()=>{
    handleMirarPasivo()
 },[open3, version])
  return (
   <Box    sx={{position: 'absolute'}}> <Modal
   open={open3}
   onClose={handleClose3}
   aria-labelledby="modal-modal-title"
   aria-describedby="modal-modal-description"

 >
   <Box className="bordes"  sx={{...style,  p:2, backgroundSize: "cover", width: {xs: '95%', md: '50%'}, height: {xs: '65%', md: '70%'}, display: { xs: 'flex', md: 'flex'}, justifyContent: 'space-around', flexDirection: 'column',overflowY: {xs: 'scroll', md: 'auto'}}}>
    <Box>
      <Button onClick={()=>setVersion("v1")} sx={{mr: 1}} variant={version === "v1" ? "contained" :'outlined'}>V1</Button>
      <Button onClick={()=>setVersion("v2")}  variant={version === "v2" ? "contained" :'outlined'}>V2</Button>
    </Box>
{ version === "v1" ?   <Box sx={{ display: { xs: 'flex', md: 'flex'}, justifyContent: 'space-around', flexDirection: 'column',overflowY: {xs: 'scroll', md: 'auto'}}}>
    <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h3">{idioma === 'es' ? 'STAKE': 'STAKE'}</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h6">{idioma === 'es' ? 'Por cada token 500 KOD y 5 token FUSION recibes semanalmente 20 TOKEN KOD, un ejemplo si stakeas 1500 KOD y 15 FUSION recibes 60 token KOD semanales.': 'For each 10000 HUESO token and 100 VIPHUESO you receive 500 TOKEN HUESO weekly, for example if you stake 20000 HUESO and 200 VIPHUESO you receive 1000 HUESO tokens weekly.'}</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? 'Minimo 1000 $HUESO y automatico se depositaran 10 $': 'Minimum 1000 $HUESO and automatic 10 $VIPHUESO will be deposited.'}</Typography>
   <TextField onChange={(e)=>setCantidad(parseInt(e.target.value))} type="number" sx={{borderTop: '1px solid white'}} id="outlined-basic" label="Deposit" variant="filled" />
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? 'Token $VIPHUESO necesario ' + Math.floor(cantidad / 50) * 0.5 + '$' : 'Token $VIPHUESO required ' + Math.floor(cantidad / 1000) * 10 + '$' }</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? `Token KOD disponible ${kod} Token $FUSION disponible ${fusion}` : `$HUESO token available ${kod} $VIPHUESO token available ${fusion}`  }</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? `Ganancias semanales del token $KOD ${(fusion/ 5) * 20}` : `Weekly earnings of the $HUESO token ${(fusion/ 100) * 500}`  }</Typography>

    </Box>
    :
    <Box sx={{ display: { xs: 'flex', md: 'flex'}, justifyContent: 'space-around', flexDirection: 'column',overflowY: {xs: 'scroll', md: 'auto'}}}>
    <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h3">{idioma === 'es' ? 'STAKE': 'STAKE'}</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h6">{idioma === 'es' ? 'Por cada token 500 KOD y 5 token FUSION recibes semanalmente 20 TOKEN KOD, un ejemplo si stakeas 1500 KOD y 15 FUSION recibes 60 token KOD semanales.': 'For each 10000 HUESO token and 100 VIPHUESO you receive 50 TOKEN HUESO weekly, for example if you stake 20000 HUESO and 200 VIPHUESO you receive 100 HUESO tokens weekly.'}</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? 'Minimo 1000 $HUESO y automatico se depositaran 10 $': 'Minimum 1000 $HUESO and automatic 10 $VIPHUESO will be deposited.'}</Typography>
   <TextField onChange={(e)=>setCantidad(parseInt(e.target.value))} type="number" sx={{borderTop: '1px solid white'}} id="outlined-basic" label="Deposit" variant="filled" />
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? 'Token $VIPHUESO necesario ' + Math.floor(cantidad / 50) * 0.5 + '$' : 'Token $VIPHUESO required ' + Math.floor(cantidad / 1000) * 10 + '$' }</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? `Token KOD disponible ${kod} Token $FUSION disponible ${fusion}` : `$HUESO token available ${kod} $VIPHUESO token available ${fusion}`  }</Typography>
   <Typography textAlign={'center'} sx={{ textShadow: '2px 2px 2px black'}} variant="h7">{idioma === 'es' ? `Ganancias semanales del token $KOD ${(fusion/ 5) * 20}` : `Weekly earnings of the $HUESO token ${(fusion/ 100) * 50}`  }</Typography>

    </Box>
    
    }

<Box sx={{ width: '100%', display: 'flex', justifyContent: 'center'}}>
<Button variant='contained' disabled={version === "v1"} onClick={depositoPasivo} sx={{m:1, width: '40%'}}>Deposit</Button>
<Button onClick={handleRetirarPasivo} sx={{m:1, width: '40%'}} variant='contained'>{idioma=== 'es'? 'Retirar' : 'Withdraw'}</Button>
</Box>
  
 
   </Box>

 
 </Modal>
 <Stack spacing={2} sx={{ width: "100%" }}>
         <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
           {
             error ?
             <Alert
             onClose={handleClose}
             severity="error"
             sx={{ width: "100%" }}
             variant="filled"
           >
            Failed
           </Alert>
           :
           <Alert
           onClose={handleClose}
           severity="success"
           sx={{ width: "100%" }}
           variant="filled"
         >
          Succes
         </Alert>
           }
         </Snackbar>
       </Stack>
 </Box>
  )
}
